import { Link } from '@tanstack/react-router';
import type { JSX } from 'react';

const TABS = [
  { to: '/orders', label: 'Inicio', exact: true },
  { to: '/orders/history', label: 'Pedidos', exact: false },
  { to: '/portal/delivery-notes', label: 'Remitos', exact: false },
  { to: '/help', label: 'Ayuda', exact: false },
] as const;

/**
 * design.md §8.2: portal-only, single consumer (`AppShell` below 640px),
 * so it does not belong in `packages/ui`. "Plantillas" is deliberately
 * left out to keep 4 items max — it stays reachable from Pedidos/Inicio.
 */
export function BottomTabBar(): JSX.Element {
  return (
    <nav
      aria-label="Navegación del portal"
      className="fixed inset-x-0 bottom-0 z-10 grid grid-cols-4 border-t border-slate-200 bg-white"
    >
      {TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          activeOptions={{ exact: tab.exact }}
          className="flex min-h-11 flex-col items-center justify-center text-xs font-medium text-slate-600"
          activeProps={{ className: 'text-primary-700' }}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
